export default "/images/navigation-2.svg?52b18e1ec557907e0b4ed2c0395a7222";